import React, { Fragment, useState, useEffect, useContext } from 'react'

import AppContext from '../../../contexts/AppContext'
import Breadcrumbs from '../../Breadcrumbs'
import Header from '../../Header'
import Footer from '../../Footer'
import BannerForm from './Form'
import { breadcrumbsBy } from '../../../services/locations'
import { truncateString } from '../../../services/posts'
import { getImages } from '../../../services/banners'
import useToastContext from "../../../hooks/useToastContext"

import { BannerStatusBages, BannerActionButtons } from './common'

import { Helmet } from "react-helmet-async";

import moment from "moment"

const Create = ({ match, history }) => {

    const { data, location, postServices, bannerServices, imageServices } = useContext(AppContext)
    const { user } = data.app

    const addToast = useToastContext()

    const title = "Create a Banner Ad"

    const [ isChecked, setIsChecked ] = useState(false)

    const [ banner, setBanner ] = useState(null)
    const [ locations, setLocations ] = useState([])
    const [ categories, setCategories ] = useState([])
    const [ images, setImages ] = useState([])
    const [ dataToSave, setDataToSave ] = useState({})

    useEffect(() => {
        const post_id = document.location.hash.replace('#', '').replace('post_id=', '')
        if(post_id){
            // populate banner info from a post
            postServices.previewPost(post_id).then(res => {
                const post = res.post
                if(post){
                    setBanner({
                        linkTo: process.env.MIX_APP_URL + '/p/' + post.post_id,
                        title: truncateString(post.title, 20),
                        description: truncateString(post.description, 75),
                        images: getImages(null, post.images),
                        templateType: 'default',
                        startsAt: moment().add(1, 'days').format('YYYY-MM-DD').toString(),
                        expiresAt: moment().add(31, 'days').format('YYYY-MM-DD').toString()
                    })
                    if(post.images) setImages(post.images)
                    if(post.category){
                        setCategories([post.category.parent_id, ...post.categories.map(item => item.id)])
                    }
                    if(post.location){
                        setLocations([{
                            id: post.location.id,
                            name: post.location.name,
                            type: post.location.type,
                            parent_name: post.location.location ? post.location.location.name : null,
                            parent_ids: [ post.location.parent_id, post.location.location ? post.location.location.parent_id : null ].filter(item => !!item),
                        }])
                    }
                }

                setIsChecked(true)
            }).catch(res => {
                setIsChecked(true)
            })
        }else{
            if(user.default_location){
                setLocations([{
                    id: user.default_location.id,
                    name: user.default_location.name,
                    type: user.default_location.type,
                    parent_name: user.default_location.location ? user.default_location.location.name : null,
                    parent_ids: [ user.default_location.parent_id, user.default_location.location ? user.default_location.location.parent_id : null ].filter(item => !!item)
                }])
            }
            setIsChecked(true)
        }
    }, [])

    useEffect(() => {
        // default banner info
        if(!banner && isChecked){
            setBanner({
                linkTo: process.env.MIX_APP_URL,
                title: 'Your Ad Title',
                description: 'Your Ad Description',
                images: getImages(),
                templateType: 'default',
                startsAt: moment().add(1, 'days').format('YYYY-MM-DD').toString(),
                expiresAt: moment().add(31, 'days').format('YYYY-MM-DD').toString()
            })
        }
    }, [ isChecked ])

    const onSave = (data, shouldPublish) => {
        return new Promise((resolve, reject) => {
            return bannerServices.create(data).then(res => {
                const bannerUpdted = res.banner
                const banner_id = bannerUpdted && bannerUpdted.id
                if(typeof data.uploadImage == 'object'){
                    return imageServices.upload(data.uploadImage, banner_id, 'App\\Banner', {replace: true}).then(res => {
                        if(shouldPublish){
                            history.push('/account/banner/pay/' + banner_id)
                        }else{
                            history.push('/account/banner/edit/' + banner_id)
                        }
                    }).catch(res => {
                        if(res && res.data && res.data.message) addToast({title: 'Error', message: res.data.message, type: 'danger'})
                        reject(res)
                    })
                }else{
                    if(shouldPublish){
                        history.push('/account/banner/pay/' + banner_id)
                    }else{
                        history.push('/account/banner/edit/' + banner_id)
                    }
                }
            }).catch(res => {
                if(res && res.data && res.data.message) addToast({title: 'Error', message: res.data.message, type: 'danger'})
                reject(res)
            })
        })
    }

    return (
        <Fragment>
            <div>
                <Header history={history} />
                <main className="py-4">
                    <div className="container">
                        <Breadcrumbs list={breadcrumbsBy(location, [{url: '/account', title: 'Dashboard'}, {url: '/account/banner/list', title: 'Banner ads list'}, {title}])} />
                        <Helmet><title>{title + ' | ' + process.env.MIX_APP_NAME}</title></Helmet>

                        <div className="d-flex justify-content-between flex-wrap">
                            <div className="me-3">
                                <h1 className="mt-0">
                                    <span className="me-2">{title}</span>
                                    <BannerStatusBages />
                                </h1>
                            </div>
                            <BannerActionButtons
                                page="create"
                                onSave={() => onSave(dataToSave)}
                                onOrder={() => onSave(dataToSave, true)}
                            />
                        </div>

                        {isChecked && banner &&
                            <BannerForm
                                initBanner={banner}
                                initLocations={locations}
                                initCategories={categories}
                                postImages={images}
                                initShowDialog="placement"
                                updateDataToSave={data => setDataToSave(data)}
                            />
                        }
                    </div>
                </main>
            </div>
            <Footer />
        </Fragment>
    )
}

export default Create
